import { useState } from "react";
import DepartmentsForm from "../DepartmentsForm";
import GroupsForm from "../GroupsForm";
import InviteSection from "./InviteSection";
import UserSection from "./UserSection";
import { UserManagementProvider } from "./UserManagementContext";
import GroupsSection from "./GroupsSection";
import DepartmentsSection from "./DepartmentsSection";
import styles from "./UserManagement.module.css";

const UserManagementComponent = () => {
  const [showDepartments, setShowDepartments] = useState(false);
  const [showGroups, setShowGroups] = useState(false);

  if (showDepartments) {
    return <DepartmentsForm closeFn={() => setShowDepartments(false)} />;
  }

  if (showGroups) {
    return <GroupsForm closeFn={() => setShowGroups(false)} />;
  }

  return (
    <div className={styles.container}>
      <InviteSection />
      <UserSection />
      <GroupsSection setShowGroups={setShowGroups} />
      <DepartmentsSection setShowDepartments={setShowDepartments} />
    </div>
  );
};

const UserManagement = () => (
  <UserManagementProvider>
    <UserManagementComponent />
  </UserManagementProvider>
);

export default UserManagement;
